// extracted by mini-css-extract-plugin
export default {"search":"_1eRPal8R"};